import { getUuid } from '@sibe/utilities/common';
import type { HsGeometry } from '../../graphic-engine-new/geometry/geometry.interface';
import type { HsMaterial } from '../../graphic-render-new/materials/material.class';
import { HsHypersceneConstants } from '../../math-new/constants/hyperscene-constants.global';
import type { HsColor } from '../../math-new/objects/color.class';
import { HsMatrix4 } from '../../math-new/objects/matrix4.class';
import { HsQuaternion } from '../../math-new/objects/quaternion.class';
import type { HsHypersceneTypes } from '../../math-new/types/hyperscene-types.type';
import { HsControlTool } from './control-tool.class';
import type { HsToolAction } from './tool-action.class';

export class HsPlaneTool extends HsControlTool {
  constructor(
    geometry: HsGeometry,
    material: HsMaterial,
    action: HsToolAction,
    rotation: HsHypersceneTypes.Array3,
    color: HsColor,
    scale: number,
    centered: boolean,
    rotationAngle: number = HsHypersceneConstants.PI_DIV_2
  ) {
    super(getUuid(), 'plane_tool', geometry, material, action);
    const rotationMatrix: HsMatrix4 = HsMatrix4.compose(
      HsHypersceneConstants.ZERO_VECTOR3.values,
      HsQuaternion.makeFromAxisAndAngle(rotation, rotationAngle).values,
      [scale, 1, scale]
    );
    this.worldMatrix.multiply(rotationMatrix);
    const offset: number = centered ? 0 : scale * 2;
    this.worldMatrix.addRelativeTransition([offset, 0, offset]);
    this.updateBoundingSphere();
    this.material.color = color;
  }
}
